/* eslint-disable no-unused-vars */
import {
    LinearProgress,
    Card,
    CardContent,
  } from "@material-ui/core";
  import { toAbsoluteUrl } from "../../../_metronic/_helpers";
  import { Button, Pagination } from "react-bootstrap";
  import Axios from "axios";
  import Moment from "moment";
  import React, { Component } from "react";
  import { withRouter } from "react-router-dom";
  import {
    NoticeDashboard,
  } from "../../../_metronic/_partials/controls";
  import AppConfig from "../../config/AppConfig";
  import swal from "sweetalert";
  
  const bgImage = toAbsoluteUrl("/media/bg/bg-5.jpg");
  
  class Notification extends Component {
    state = {
      id_unit: "",
      keyword: "",
      jenis_pengaturan: "",
      limit: 10,
  
      data: [],
      loading: false,
      totalRows: 0,
      perPage: 10,
      activePage: 1,
    };
  
    componentDidMount() {
      this.getNotifications();
    }
  
    onInputChangeName = (e, type) => {
      this.setState({
        [type]: e.target.value,
      });
    };
  
    ResetFilter = (e) => {
      e.preventDefault();
      this.setState(
        {
          keyword: "",
          jenis_pengaturan: "",
          activePage: 1,
        },
        () => this.getNotifications()
      );
    };
  
    getNotifications = async (page = 1) => {
      this.setState({ loading: true });
  
      try {
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let id_sp = sessiondata.i_idunit;
        let session = "";
  
        if (userdata) {
          session =
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            id_sp +
            "&id_role=" +
            sessiondata.i_idrole;
        }
  
        const formData = new FormData();
        formData.append("data[id_unit]", sessiondata.i_idunit);
        formData.append("data[id_bp]", sessiondata.i_idbp);
        formData.append("data[mengisi]", this.state.keyword);
        formData.append("data[jenis]", this.state.jenis_pengaturan);
  
        if (sessiondata.id_sp_penugasan !== null && sessiondata.i_idrole === 2013) {
          let data_pt = "'" + sessiondata.id_sp_penugasan.join("','") + "'";
          formData.append("data[id_sp]", data_pt);
        }
  
        const response = await Axios.post(
          AppConfig.GetNotifSelainPT +
            session +
            `&limit=${this.state.limit}&page=${page}`,
          formData
        );
  
        this.setState({
          data: response.data.result.data_detail,
          totalRows: response.data.result.total_notifikasi,
          loading: false,
          activePage: page,
        });
      } catch (err) {
        console.error("Error fetching notifications:", err);
        this.setState({
          loading: false,
        });
      }
    };
  
    SearchInstitusi = () => {
      this.setState({ activePage: 1 }, () => this.getNotifications());
    };
  
    renderPagination = () => {
      const { activePage, perPage, totalRows } = this.state;
      const totalPages = Math.ceil(totalRows / perPage);
      let items = [];
  
      for (let number = 1; number <= totalPages; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === activePage}
            onClick={() => this.getNotifications(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
  
      return <Pagination>{items}</Pagination>;
    };
  
    handleClick = async (notif, link, e) => {
        e.preventDefault();
    
        if (notif.is_read_reviewer === 0) {
          try {
            const formData = new FormData();
            formData.append("data[id_notif]", notif.id_notif);
    
            const response = await Axios.post(AppConfig.ReadNotifReviewer, formData);
    
            if (response.data.status === "sukses") {
                window.open(`/${link}/${notif.id_pt}`, "_blank");
                // this.getNotifications(number);
                const { activePage, perPage, totalRows } = this.state;
                const totalPages = Math.ceil(totalRows / perPage);
                let items = [];
            
                for (let number = 1; number <= totalPages; number++) {
                    items.push(
                        this.getNotifications(number)
                    );
                }
            } else {
              swal({
                title: "Gagal!",
                text: "Gagal mengubah status baca notifikasi!",
                icon: "error",
                button: "OK!",
              });
            }
          } catch (error) {
            console.error("Update failed:", error);
            swal({
              title: "Gagal!",
              text: "Gagal mengubah status baca notifikasi!",
              icon: "error",
              button: "OK!",
            });
          }
        } 
      };
    render() {
      const {
        loading,
        data,
        totalRows,
        keyword,
        jenis_pengaturan,
      } = this.state;
  
      return (
        <>
          <NoticeDashboard
            className="bg-primary"
            style={{ boxShadow: "none", backgroundImage: `url(${bgImage})` }}
          >
            <strong className="text-white" style={{ fontSize: "18px" }}>
              Pemberitahuan
            </strong>
            <p className="text-white">
              Pemantauan Perguruan Tinggi Yang Telah Mengisi Aspek Pengaturan Kebijakan SPMI
            </p>
  
            <div className="col-md-12 text-white">
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label text-white">
                  Kata Kunci
                </label>
                <div className="col-lg-9 col-xl-6">
                  <input
                    type="text"
                    value={keyword}
                    onChange={(e) => this.onInputChangeName(e, "keyword")}
                    className="form-control form-control-lg form-control-solid"
                    placeholder="Masukkan nama Perguruan Tinggi"
                  />
                </div>
              </div>
  
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 text-white">Lingkup Koordinasi</label>
                <div className="col-lg-9 col-xl-6">
                  <select
                    value={jenis_pengaturan}
                    onChange={(e) => this.onInputChangeName(e, "jenis_pengaturan")}
                    className="form-control form-control-lg form-control-solid"
                  >
                    <option value="">Semua Pengaturan</option>
                    <option value="1">Penetapan</option>
                    <option value="2">Evaluasi</option>
                    <option value="3">Pengendalian</option>
                    <option value="4">Peningkatan</option>
                  </select>
                </div>
              </div>
  
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label"></label>
                <div className="col-lg-9 col-xl-6 text-center">
                  <Button variant="primary" onClick={this.SearchInstitusi}>
                    Filter Data &nbsp;&nbsp;
                    <span className="fa fa-search" />
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={this.ResetFilter}
                    style={{ marginLeft: "10px" }}
                  >
                    Reset &nbsp;&nbsp;
                    <span className="fa fa-times" />
                  </Button>
                </div>
              </div>
            </div>
          </NoticeDashboard>
  
          <Card className="mt-5">
            <CardContent>
              <h5 className="mb-4">Pemberitahuan</h5>
  
              {loading && <LinearProgress />}
  
              {!loading && data.length === 0 && (
                <p className="text-muted">Belum ada notifikasi ditemukan.</p>
              )}
  
              {!loading &&
                data.map((item, idx) => (
                  <div
                    key={idx}
                    className={`d-flex align-items-start mb-4 p-3 rounded shadow-sm ${
                      item.is_read_reviewer ? "bg-light" : "bg-white"
                    }`}
                  >
                    <div className="mr-3">
                      <i
                        className={`fa ${
                          item.is_read_reviewer ? "fa-bell text-muted" : "fa-bell text-primary"
                        }`}
                        style={{ fontSize: "1.5rem" }}
                      ></i>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1 d-flex justify-content-between align-items-center">
                        {item.jenis_notif || "Judul Notifikasi"}
                        {(item.is_read_reviewer === 0 || Moment(item.tgl_create).isAfter(Moment().subtract(1, "month"))) && (
                            <span className="badge badge-primary">Pesan baru</span>
                        )}
                      </h6>
                      <p className="mb-1 text-muted" style={{ fontSize: "0.9rem" }}>
                        Perguruan Tinggi {item.nm_lemb} telah menyimpan pengaturan jenis {item.jenis_notif}
                      </p>
                      <p>
                        <a
                          href="#"
                          onClick={(e) => this.handleClick(item, "detail-pt", e)}
                          className="navi-item"
                        >
                          <i className="mb-1 text-primary" style={{ fontSize: "0.9rem" }}>
                            Klik di sini untuk melihat detail perguruan tinggi {item.nm_lemb}
                          </i>
                        </a>
                      </p>
                      <small className="text-muted">
                        {Moment(item.tgl_create || new Date()).fromNow()}
                      </small>
                    </div>
                  </div>
                ))}
  
              {totalRows > this.state.perPage && (
                <div className="mt-4 d-flex justify-content-center">
                  {this.renderPagination()}
                  <p>
                  </p>
                </div>
              )}

                <div className="mt-4 d-flex justify-content-center" >
                  <span className="text-center text-muted"><i style={{ fontSize: "0.9rem" }}>Total Notifications : {totalRows}</i></span>
                </div>
            </CardContent>
          </Card>
        </>
      );
    }
  }
  
  export default withRouter(Notification);
  